import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function TrendUpIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52174 19.998L9.05953 13.4749L12.0425 16.4579L19.9996 7.5054V10.0003H21.9996V4.00028H15.9996V6.00028H18.6616L11.9568 13.5438L8.93928 10.5263L1.99707 18.7037L3.52174 19.998Z",
    fill: "currentColor"
  }));
}